import {
  CLEAR_ERRORS,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  TIMEOUT,
  PROFILE_TIMEOUT,
  SET_USER_ROLE,
  USER_LOADED,
} from '../types'

export default (state, action) => {
  switch (action.type) {
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: action.payload,
      }
    case LOGIN_SUCCESS: {
      localStorage.setItem('token', JSON.stringify(action.payload))
      return {
        ...state,
        token: action.payload,
        user: action.payload,
        isAuthenticated: true,
        loading: false,
      }
    }
    case LOGOUT:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        userRole: null,
        error: 'Successfully logged out',
      }
    case LOGIN_FAIL:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        userRole: null,
        error: 'Log in failed - Invalid Credentials',
      }
    case TIMEOUT:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        userRole: null,
        error: 'Timed out - Please log back in',
      }
    case PROFILE_TIMEOUT:
      localStorage.removeItem('token')
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        userRole: null,
        error: 'Timed out - Please log back in',
      }
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      }
    case SET_USER_ROLE:
      return {
        ...state,
        userRole: action.payload,
      }
    default:
      return state
  }
}
